// stripHtmlAndTruncate.js

export function stripHtmlAndTruncate(html, maxLength) {
  if (!html) return "";

  // Create a temporary element to leverage the browser's HTML parser
  const temp = document.createElement("div");
  temp.innerHTML = html;

  // Extract text content (this strips all tags)
  const text = (temp.textContent || temp.innerText || "").trim();

  // If short enough, return as-is
  if (text.length <= maxLength) return text;

  // Otherwise truncate and add ellipsis
  return text.slice(0, maxLength).trimEnd() + "…";
}
